import { Undo2 } from 'lucide-react';
import { Tooltip } from './Tooltip';

interface CorrectionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
}

const correctionBtnClass =
  'inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-stand bg-flaeche-2 hover:bg-flaeche-2 rounded transition-colors';

export function CorrectionButton({
  onClick,
  disabled = false,
  tooltip = 'Korrektur anfordern',
}: CorrectionButtonProps) {
  return (
    <Tooltip content={tooltip}>
      <button onClick={onClick} disabled={disabled} className={correctionBtnClass}>
        <Undo2 className="w-3.5 h-3.5" />
        <span>Korrektur</span>
      </button>
    </Tooltip>
  );
}
